function cov_15d0spgams() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/InviteFilled.tsx";
  var hash = "a154589d20ef586597c5a3685c8d873d8a5c4764";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/InviteFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 12,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a154589d20ef586597c5a3685c8d873d8a5c4764"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_15d0spgams = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_15d0spgams();
var Icon = (cov_15d0spgams().s[0]++, {
  name: 'invite-filled',
  svg: "<g clip-path=\"url(#clip0_8546_22696)\">\n  <path d=\"M20 15.75C19.7 15.75 19.45 15.65 19.25 15.45C19.05 15.25 18.95 15 18.95 14.7V12.8H17.05C16.75 12.8 16.5 12.7 16.3 12.5C16.1 12.3 16 12.05 16 11.75C16 11.45 16.1 11.2 16.3 11C16.5 10.8 16.75 10.7 17.05 10.7H18.95V8.8C18.95 8.5 19.05 8.25 19.25 8.05C19.45 7.85 19.7 7.75 20 7.75C20.3 7.75 20.55 7.85 20.75 8.05C20.95 8.25 21.05 8.5 21.05 8.8V10.7H22.95C23.25 10.7 23.5 10.8 23.7 11C23.9 11.2 24 11.45 24 11.75C24 12.05 23.9 12.3 23.7 12.5C23.5 12.7 23.25 12.8 22.95 12.8H21.05V14.7C21.05 15 20.95 15.25 20.75 15.45C20.55 15.65 20.3 15.75 20 15.75ZM10.875 13.9C9.725 13.9 8.73733 13.4873 7.912 12.662C7.08733 11.8373 6.675 10.85 6.675 9.7C6.675 8.53333 7.08733 7.54167 7.912 6.725C8.73733 5.90833 9.725 5.5 10.875 5.5C12.0417 5.5 13.0373 5.90833 13.862 6.725C14.6873 7.54167 15.1 8.53333 15.1 9.7C15.1 10.85 14.6873 11.8373 13.862 12.662C13.0373 13.4873 12.0417 13.9 10.875 13.9Z\" fill=\"currentColor\"/>\n  <path d=\"M3.97961 17.8499C5.07231 16.0785 7.0049 15 9.08614 15H12.7528C14.834 15 16.7666 16.0785 17.8593 17.8499L18.5379 18.95C19.3599 20.2824 18.4014 22 16.8358 22H5.00316C3.43755 22 2.479 20.2824 3.30099 18.95L3.97961 17.8499Z\" fill=\"currentColor\"/>\n  </g>\n  <defs>\n  <clipPath id=\"clip0_8546_22696\">\n  <rect width=\"24\" height=\"24\" fill=\"currentColor\"/>\n  </clipPath>\n  </defs>"
});
export default Icon;